import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductType } from 'src/app/Enums/productType';
import { AddProductVm, SearchTagsArrayList, SearchTagsModel } from 'src/app/models/product/addProduct.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from '../../../../../../../environments/environment';
providers: [CurrencyPipe]

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.css']
})
export class ProductAddComponent implements OnInit {
  tinyMCEkey: string;
  Loader: boolean = false;
  getCategories: [];
  companyAddressListing: [];
  selectedDiscountValue: string;
  selectedJustAddedValue: string;
  selectedSaleValue: string;
  selectedquoteValue: string;
  selectedShippingRequiredValue: string;
  selectedCategory: [];
  selectedSearchTag: [];
  selectedAddress: [];
  addProduct: AddProductVm;
  formattedAmount;
  searchValue: string = "";
  searchTagsListing: SearchTagsModel;
  searchTagsResponseModel: SearchTagsArrayList = new SearchTagsArrayList();
  selectSerchTags: string;
  productType: Array<string>;
  productTypeSelectedId: string;
  selectedAccessoriesValue: string;

  constructor(private currencyPipe : CurrencyPipe, private localstorage: LocalstorageService, private _productService: ProductService, private alertify: AlertifyService, private router: Router) {
    this.localstorage.setMenu("5");
    this.addProduct = new AddProductVm();
    this.searchTagsListing = new SearchTagsModel();
  }

  ngOnInit() {
    this.tinyMCEkey = environment.tinyMCEKey;
    this.getAllCategories();
    this.getCompanyAddress();
    this.addSearchTags();
    var productTypeValue = new Array<string>();  
    Object.values(ProductType).map(function(key){       
      if (typeof(key) == 'string') {
        productTypeValue.push(key);
      }  
    });
    this.productType = productTypeValue;
    this.selectProductType('2');
  }

  transformAmount(element) {
    this.formattedAmount = this.currencyPipe.transform(this.formattedAmount, '$');
    element.target.value = this.formattedAmount;
}

  getAllCategories() {
    this._productService.getCategories().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getCategories = responseBody.responseData;
      }
    });
  }

  addSearchTags() {  
    this._productService.searchTagsListing(this.searchTagsListing).subscribe(response => {
      this.Loader = false;
      var searchTagsList = JSON.parse(response._body);
      if (searchTagsList.isSuccess) {
        this.searchTagsResponseModel.searchTagsAllList = searchTagsList.responseData;
      } (err) => {
        this.Loader = false;
      }
    });
}

  getCompanyAddress() {
    this._productService.getAllCompanyAddress()
    .subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.companyAddressListing = responseBody.responseData;
      }
    });
  } 

  companyAddress(selectedValue){
    this.selectedAddress = selectedValue;
    this.addProduct.CompanyAddressId = this.selectedAddress.toString();
  }

  selectDiscountActive(selectedValue) {
    this.selectedDiscountValue = selectedValue;
    this.addProduct.IsShowDiscount = this.selectedDiscountValue;
  }

  selectJustAdded(selectedValue) {
    this.selectedJustAddedValue = selectedValue;
    this.addProduct.IsJustAdded = this.selectedJustAddedValue;
  }

  selectSale(selectedValue) {
    this.selectedSaleValue = selectedValue;
    this.addProduct.IsSale = this.selectedSaleValue;
  }

  selectAccessories(selectedValue) {
    this.selectedAccessoriesValue = selectedValue;
    this.addProduct.IsAccessories = this.selectedAccessoriesValue;
  }

  selectQuote(selectedValue) {
    this.selectedquoteValue = selectedValue;
    this.addProduct.IsQuote = this.selectedquoteValue;
  }

  getSelectedCategory(selectedValue) {
    this.selectedCategory = selectedValue;
    this.addProduct.CategoryIds = this.selectedCategory.toString();
  }

  selectShippingRequired(selectedValue) {
    this.selectedShippingRequiredValue = selectedValue;
    this.addProduct.IsShippingRequired = this.selectedShippingRequiredValue;
  }

  selectProductType(selectedValue) {
    this.addProduct.ProductType = selectedValue;
  }

  getSearchTags(selectedValue) {
    if (typeof(selectedValue) === 'object' && selectedValue !== null) {
      for (var i = 0; i < selectedValue.length; i++) {
        if (typeof(selectedValue[i]) === 'object') {
          if ('label' in selectedValue[i]) {
            selectedValue[i] = selectedValue[i].label;
          } else {            
            selectedValue[i] = selectedValue[i].$ngOptionLabel;
          }
        }
      }
    }
    this.selectedSearchTag = selectedValue;
    this.addProduct.SearchTags = this.selectedSearchTag.toString();
  }

  getFeaturesData() {
    var featureEditorElement: HTMLIFrameElement = document.getElementById('Features_ifr') as HTMLIFrameElement
    this.addProduct.Features = featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
  }

  getDescriptionData() {
    var descriptionEditorElement: HTMLIFrameElement = document.getElementById('Description_ifr') as HTMLIFrameElement
    this.addProduct.Description = descriptionEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
  }


  onSubmit() {
    if (this.addProduct.ProductName == undefined || this.addProduct.ProductName == null || this.addProduct.ProductName == "") {
      this.alertify.error("Product Name is required");
      return;
    }
    if (this.addProduct.ProductTitle == undefined || this.addProduct.ProductTitle == null || this.addProduct.ProductTitle == "") {
      this.alertify.error("Product Title is required");
      return;
    }
    if (this.addProduct.Length == undefined || this.addProduct.Length == null || this.addProduct.Length == "") {
      this.alertify.error("Length is required");
      return;
    }
    if (this.addProduct.Width == undefined || this.addProduct.Width == null || this.addProduct.Width == "") {
      this.alertify.error("Width is required");
      return;
    }
    if (this.addProduct.Height == undefined || this.addProduct.Height == null || this.addProduct.Height == "") {
      this.alertify.error("Height is required");
      return;
    }
    if (this.addProduct.Weight == undefined || this.addProduct.Weight == null || this.addProduct.Weight == "") {
      this.alertify.error("Product Title is required");
      return;
    }
    if (this.addProduct.Price == undefined || this.addProduct.Price == null) {
      this.alertify.error("Price is required");
      return;
    }
    this.Loader = true;
    this.addProduct.Height = this.addProduct.Height.toString();
    this.addProduct.Length = this.addProduct.Length.toString();
    this.addProduct.Weight = this.addProduct.Weight.toString();
    this.addProduct.Width = this.addProduct.Width.toString();
    this._productService.addProduct(this.addProduct).subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.addProduct = responseBody.responseData;
        this.alertify.success(responseBody.responseMessage);
        this.router.navigate(['productListing']);
      } else {
        this.alertify.error(responseBody.responseMessage);
      }
      this.Loader = false;
    });
  }

  }
